import AdminLink from "components/AdminLink";

export const SlideAdminLink = ({
  slideId,
  caseId,
}: {
  caseId?: number;
  slideId: number;
}) => {
  return (
    <div className="nav__link">
      <AdminLink
        route={
          caseId
            ? `/admin/cases/${caseId}/slides/${slideId}/`
            : `/admin/slides/${slideId}`
        }
        title="Slide Admin"
      />
    </div>
  );
};
